module.exports = __webpack_public_path__ + "static/wirelesssocial-logo-f32d44ee938bae4ab923905e65c57060.png";